// Material UI Library
import Box from '@mui/material/Box';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Chip from '@mui/material/Chip';
import FormHelperText from '@mui/material/FormHelperText';

// Translation Library
import { useTranslation } from 'react-i18next';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
const academicLevelOptionsEn = {
  student: "Dental Student (Undergraduate – Graduate Studies)",
  doctor: "Physician (Specialist – Practitioner)"
};


const academicLevelOptionsAr = {
  student: "طالب طب أسنان ( مرحلة جامعة أولى - دراسات عليا )",
  doctor: " طبيب ( اختصاصي - ممارس )"
};


// make the object as Array and take the keys [key1, key2, key3,...]
const academicLevelEn = Object.keys(academicLevelOptionsEn);
const academicLevelAr = Object.keys(academicLevelOptionsAr);

export default function AcademicLevel({formData, handleChange, errorsData}) {
    const { t,i18n } = useTranslation();

  return (
    <>
      <FormControl className="flex-1">
        <InputLabel error={errorsData.academic_level}>{t("academic_level")}</InputLabel>
        <Select
            error={errorsData.academic_level}
            name='academic_level'
            value={formData.academic_level}
            onChange={handleChange}
            input={<OutlinedInput label={t("academic_level")} />}
            renderValue={(selected) =>{
              return selected ? (
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                      {i18n.language === "en" ? <Chip label={academicLevelOptionsEn[selected]} /> : <Chip label={academicLevelOptionsAr[selected]} />}
                  </Box>
              ) : (
                  <></>
              )}
            }
            MenuProps={MenuProps}
        >
        {i18n.language === "en" 
        ?(
          academicLevelEn.map((key) => (
            <MenuItem 
            key={key} 
            value={key}
            >
              {academicLevelOptionsEn[key]}
            </MenuItem>
          ))
        )
        :(
          academicLevelAr.map((key) => (
            <MenuItem key={key} value={key}>
              {academicLevelOptionsAr[key]}
            </MenuItem>
          ))
        )
        }
        </Select>
        {errorsData.academic_level ? (
        <FormHelperText sx={{ color: 'error.main' }}>{t("please_select_one_of_academic_level")}</FormHelperText>
        ): ""}
      </FormControl>
    </>
  );
}
